// @flow
import { Record, Set as SetImmutable } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

export const RolloverTypeEnum = Object.freeze({
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
  BOTH: 'BOTH',
  IGNORE: 'IGNORE',
});
export type RolloverType = $Values<typeof RolloverTypeEnum>; // eslint-disable-line no-undef

type FreeToSpendType = {
  id: ?string,
  clientId: ?string,
  isDeleted: ?boolean,
  createdAt: ?string,
  modifiedAt: ?string,
  userModifiedAt: ?string,

  calculatedRolloverAmount: ?number,
  calculatedIncomeAmount: ?number,
  incomeTxnIds: ?SetImmutable<string>,
  excludedIncomeTxnIds: ?SetImmutable<string>,
  overwrittenIncomeAmount: ?number,

  calculatedBillsAmount: ?number,
  billsTxnIds: ?SetImmutable<string>,
  excludedBillsTxnIds: ?SetImmutable<string>,
  overwrittenBillsAmount: ?number,

  calculatedSubscriptionsAmount: ?number,
  subscriptionsTxnIds: ?SetImmutable<string>,
  excludedSubscriptionsTxnIds: ?SetImmutable<string>,

  calculatedSavingsAmount: ?number,
  savingsTxnIds: ?SetImmutable<string>,
  excludedSavingsTxnIds: ?SetImmutable<string>,

  calculatedGoalsAmount: ?number,
  goalsIds: ?SetImmutable<string>,
  excludedGoalsIds: ?SetImmutable<string>,
  overwrittenGoalsAmount: ?number,

  setAside: ?number,
  spentAmount: ?number,
  spentTxnIds: ?SetImmutable<string>,
  excludedSpentTxnIds: ?SetImmutable<string>,
  totalToSpendAmount: ?number,
  leftToSpendAmount: ?number,
  rolloverPreference: ?RolloverType,
  date: ?string,
};

export type FreeToSpend = RecordOf<FreeToSpendType>;
const mkFreeToSpendDefaults: RecordFactory<FreeToSpendType> =
  Record({
    id: undefined,
    clientId: undefined,
    isDeleted: undefined,
    createdAt: undefined,
    modifiedAt: undefined,
    userModifiedAt: undefined,

    calculatedRolloverAmount: undefined,
    calculatedIncomeAmount: undefined,
    incomeTxnIds: undefined,
    excludedIncomeTxnIds: undefined,
    overwrittenIncomeAmount: undefined,

    calculatedBillsAmount: undefined,
    billsTxnIds: undefined,
    excludedBillsTxnIds: undefined,
    overwrittenBillsAmount: undefined,

    calculatedSubscriptionsAmount: undefined,
    subscriptionsTxnIds: undefined,
    excludedSubscriptionsTxnIds: undefined,

    calculatedSavingsAmount: undefined,
    savingsTxnIds: undefined,
    excludedSavingsTxnIds: undefined,

    calculatedGoalsAmount: undefined,
    goalsIds: undefined,
    excludedGoalsIds: undefined,
    overwrittenGoalsAmount: undefined,

    setAside: undefined,
    spentAmount: undefined,
    spentTxnIds: undefined,
    excludedSpentTxnIds: undefined,
    totalToSpendAmount: undefined,
    leftToSpendAmount: undefined,
    rolloverPreference: RolloverTypeEnum.IGNORE,
    date: undefined,
  });

export const mkFreeToSpend = (jsObj: Object = {}): FreeToSpend => mkFreeToSpendDefaults({
  ...jsObj,
  incomeTxnIds: jsObj.incomeTxnIds && SetImmutable(jsObj.incomeTxnIds),
  excludedIncomeTxnIds: jsObj.excludedIncomeTxnIds && SetImmutable(jsObj.excludedIncomeTxnIds),

  billsTxnIds: jsObj.billsTxnIds && SetImmutable(jsObj.billsTxnIds),
  excludedBillsTxnIds: jsObj.excludedBillsTxnIds && SetImmutable(jsObj.excludedBillsTxnIds),

  subscriptionsTxnIds: jsObj.subscriptionsTxnIds && SetImmutable(jsObj.subscriptionsTxnIds),
  excludedSubscriptionsTxnIds: jsObj.excludedSubscriptionsTxnIds && SetImmutable(jsObj.excludedSubscriptionsTxnIds),

  savingsTxnIds: jsObj.savingsTxnIds && SetImmutable(jsObj.savingsTxnIds),
  excludedSavingsTxnIds: jsObj.excludedSavingsTxnIds && SetImmutable(jsObj.excludedSavingsTxnIds),

  spentTxnIds: jsObj.spentTxnIds && SetImmutable(jsObj.spentTxnIds),
  excludedSpentTxnIds: jsObj.excludedSpentTxnIds && SetImmutable(jsObj.excludedSpentTxnIds),

  goalsIds: jsObj.goalsIds && SetImmutable(jsObj.goalsIds),
  excludedGoalsIds: jsObj.excludedGoalsIds && SetImmutable(jsObj.excludedGoalsIds),
});
